export type ThreadKind = 'agent_chat' | 'flow_output'

export type MockConversation = {
  id: string
  title: string
  message_count: number
  updated_at: string
  preview?: string
  isStreaming?: boolean
  /** Option B: same as `threads.kind` - drives sidebar filter and badge */
  kind: ThreadKind
}

export const THREAD_KIND_META: Record<ThreadKind, { label: string; dotClass: string; chipClass: string }> = {
  agent_chat: {
    label: 'Chat',
    dotClass: 'bg-blue-500',
    chipClass: 'border-blue-500/30 bg-blue-500/10 text-blue-600 dark:text-blue-400',
  },
  flow_output: {
    label: 'Flow',
    dotClass: 'bg-violet-500',
    chipClass: 'border-violet-500/30 bg-violet-500/10 text-violet-600 dark:text-violet-400',
  },
}

export const MOCK_CONVERSATIONS: MockConversation[] = [
  {
    id: 'conv-beef-marinade',
    title: 'Asian Beef Marinade Ratios & Velvetin...',
    message_count: 2,
    updated_at: '2026-05-29T18:00:00.000Z',
    preview: 'What ratios work best for velveting beef for stir fry?',
    isStreaming: true,
    kind: 'agent_chat',
  },
  {
    id: 'conv-inbox-flows',
    title: 'Inbox: Hello from Flows Engine v1',
    message_count: 1,
    updated_at: '2026-05-29T12:00:00.000Z',
    preview: 'Hello from Flows Engine v1',
    kind: 'flow_output',
  },
  {
    id: 'conv-ingest-test',
    title: 'Ingesting: test todo',
    message_count: 21,
    updated_at: '2026-05-28T20:00:00.000Z',
    preview: 'Ingest this Basecamp todo into FlowNotes',
    kind: 'agent_chat',
  },
  {
    id: 'conv-mailchimp',
    title: 'Updating: Fix Mailchimp subscription...',
    message_count: 19,
    updated_at: '2026-05-28T14:00:00.000Z',
    preview: 'Help update the Mailchimp subscription fix work spec',
    kind: 'agent_chat',
  },
  {
    id: 'conv-rag-embed',
    title: 'RAG Document Vector & Embedding...',
    message_count: 2,
    updated_at: '2026-05-27T16:00:00.000Z',
    preview: 'How do document vectors get embedded?',
    kind: 'agent_chat',
  },
  {
    id: 'conv-broken-links',
    title: 'Ingesting: URGENT - Broken Links Issue',
    message_count: 4,
    updated_at: '2026-05-26T10:00:00.000Z',
    preview: 'Ingest the broken links todo urgently',
    kind: 'agent_chat',
  },
  {
    id: 'conv-flow-daily-digest',
    title: 'Flow: Daily digest - 2026-05-28',
    message_count: 3,
    updated_at: '2026-05-28T08:00:00.000Z',
    preview: 'Your daily digest is ready. 3 items need attention.',
    kind: 'flow_output',
  },
]

export function getConversationTitle(id: string): string {
  return MOCK_CONVERSATIONS.find((c) => c.id === id)?.title ?? 'New chat'
}

export function formatConversationDate(iso: string): string {
  const d = new Date(iso)
  return d.toLocaleDateString(undefined, { month: 'numeric', day: 'numeric', year: 'numeric' })
}

export function groupConversationsByDay(
  conversations: MockConversation[],
): { label: string; items: MockConversation[] }[] {
  const today = new Date()
  today.setHours(0, 0, 0, 0)
  const yesterday = new Date(today)
  yesterday.setDate(yesterday.getDate() - 1)

  const groups: Record<string, MockConversation[]> = {}

  for (const conv of conversations) {
    const d = new Date(conv.updated_at)
    d.setHours(0, 0, 0, 0)
    let label = 'Older'
    if (d.getTime() === today.getTime()) label = 'Today'
    else if (d.getTime() === yesterday.getTime()) label = 'Yesterday'
    else if (d.getTime() > today.getTime() - 7 * 86400000) label = 'Last 7 days'

    if (!groups[label]) groups[label] = []
    groups[label].push(conv)
  }

  const order = ['Today', 'Yesterday', 'Last 7 days', 'Older']
  return order
    .filter((label) => groups[label]?.length)
    .map((label) => ({ label, items: groups[label]! }))
}
